import { render, staticRenderFns } from "./ViewDeliveryZoneView.vue?vue&type=template&id=0b90b996"
import script from "./ViewDeliveryZoneView.vue?vue&type=script&lang=js"
export * from "./ViewDeliveryZoneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports